/* Edge — tap the print to see it full screen */
(function () {
  var img = document.querySelector('[data-pdp-img]');
  if (!img || img.tagName !== 'IMG') return;

  var st = document.createElement('style');
  st.textContent =
    '[data-pdp-img]{cursor:zoom-in}' +
    '.zoom{position:fixed;inset:0;z-index:100;background:#141414;color:#F3F2EE;opacity:0;transition:opacity 250ms ease;cursor:zoom-out;touch-action:pinch-zoom}' +
    '.zoom.is-on{opacity:1}' +
    '.zoom__img{position:absolute;left:24px;right:24px;top:56px;bottom:56px;display:flex;align-items:center;justify-content:center}' +
    '.zoom__img img{width:100%;height:100%;max-width:none;object-fit:contain;transform:scale(.98);transition:transform 350ms cubic-bezier(.2,.7,.2,1)}' +
    '.zoom.is-on .zoom__img img{transform:none}' +
    '.zoom__t{position:absolute;left:var(--pad);top:20px;right:120px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.zoom__x{position:absolute;right:8px;top:8px;padding:12px 16px;min-height:44px;color:#F3F2EE}' +
    '.zoom__x:hover{color:#9A9993}' +
    '.zoom__h{position:absolute;left:var(--pad);bottom:20px;color:#9A9993}' +
    '@media (max-width:749px){.zoom__img{left:0;right:0;top:52px;bottom:48px}.zoom__t{top:18px}}';
  document.head.appendChild(st);

  var title = (document.querySelector('.pdp__edge-l') || {}).textContent || '';
  img.setAttribute('tabindex', '0');
  img.setAttribute('role', 'button');
  img.setAttribute('aria-label', 'View ' + img.alt + ' full screen');

  var box = null, last = null;
  var close = function () {
    if (!box) return;
    var b = box; box = null;
    b.classList.remove('is-on');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { b.remove(); }, 260);
    if (last) last.focus();
  };
  var onKey = function (e) { if (e.key === 'Escape') close(); };
  var open = function () {
    if (box) return;
    last = document.activeElement;
    box = document.createElement('div');
    box.className = 'zoom';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', img.alt);
    box.innerHTML =
      '<div class="zoom__t"></div>' +
      '<button type="button" class="zoom__x">(Close)</button>' +
      '<div class="zoom__img"><img alt=""></div>' +
      '<div class="zoom__h">Tap or press Esc to close</div>';
    box.querySelector('.zoom__t').textContent = title.trim();
    var big = box.querySelector('.zoom__img img');
    big.alt = img.alt;
    big.src = img.currentSrc || img.src;
    var full = img.getAttribute('data-full');
    if (full) { var pre = new Image(); pre.onload = function () { big.src = full; }; pre.src = full; }
    box.addEventListener('click', close);
    document.body.appendChild(box);
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey);
    void box.offsetWidth;
    box.classList.add('is-on');
    box.querySelector('.zoom__x').focus();
  };
  img.addEventListener('click', open);
  img.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
})();
